import * as React from 'react';
import UITruncateString from 'UIComponents/text/UITruncateString';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getInternalListDisplayNameKey } from 'flow-doctor-lib/utils/listMembershipTimelineUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const InternalListNameLabel = ({
  logItem
}) => {
  return /*#__PURE__*/_jsx(UITruncateString, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: getInternalListDisplayNameKey(logItem),
      elements: {
        b: 'b'
      },
      options: {
        listId: logItem.data.objectListMembership.listId,
        listVersion: logItem.data.objectListMembership.listVersion
      }
    })
  });
};
export default InternalListNameLabel;